import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateChildFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { AppRole } from './app-role';
import { AuthService } from './auth.service';

function requireAuthenticatedSession(loginPath = '/customer/login'): boolean | UrlTree {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  authService.hydrate();

  return authService.isAuthenticated() ? true : router.parseUrl(loginPath);
}

export const authCanMatch: CanMatchFn = () => requireAuthenticatedSession();

export const authCanActivateChild: CanActivateChildFn = () => requireAuthenticatedSession();

function requireRoleSession(role: AppRole): boolean | UrlTree {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loginPath = `/${role}/login`;
  const authenticated = requireAuthenticatedSession(loginPath);

  if (authenticated !== true) {
    return authenticated;
  }

  return authService.hasRole(role) ? true : router.parseUrl(loginPath);
}

export const roleCanMatch = (role: AppRole): CanMatchFn => () => requireRoleSession(role);

export const roleCanActivateChild = (role: AppRole): CanActivateChildFn => () =>
  requireRoleSession(role);